/* tslint:disable */
/* eslint-disable */
/**
 * TOM BILLING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Container } from '../model';
// @ts-ignore
import type { ContainerJourneyDto } from '../model';
// @ts-ignore
import type { ContainerTurnoverDto } from '../model';
// @ts-ignore
import type { GCStorageDataResult } from '../model';
// @ts-ignore
import type { HandlingServicesDataResult } from '../model';
// @ts-ignore
import type { ServiceOrderReportDto } from '../model';
// @ts-ignore
import type { StorageReportEntry } from '../model';
// @ts-ignore
import type { StorageReportType } from '../model';
// @ts-ignore
import type { StorageSummaryDto } from '../model';
// @ts-ignore
import type { VesselReportContainerEntry } from '../model';
// @ts-ignore
import type { VesselSummaryDto } from '../model';
/**
 * ExportApi - axios parameter creator
 */
export const ExportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        exportBillableItemsReport: async (customerId?: number, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Export/billableItemsReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['CustomerId'] = customerId;
            }

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [isDangerous] 
         * @param {boolean} [isDamaged] 
         * @param {boolean} [includeContainerNumber] 
         * @param {boolean} [includeIsoCode] 
         * @param {boolean} [includeOperator] 
         * @param {boolean} [includeGrossWeight] 
         * @param {boolean} [includeIsOOG] 
         * @param {boolean} [includeIsReefer] 
         * @param {boolean} [includeIsEmpty] 
         * @param {boolean} [includeIsDangerous] 
         * @param {boolean} [includeEntryDateTime] 
         * @param {boolean} [includeIsDamaged] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        exportContainerTurnovers: async (isDangerous?: boolean, isDamaged?: boolean, includeContainerNumber?: boolean, includeIsoCode?: boolean, includeOperator?: boolean, includeGrossWeight?: boolean, includeIsOOG?: boolean, includeIsReefer?: boolean, includeIsEmpty?: boolean, includeIsDangerous?: boolean, includeEntryDateTime?: boolean, includeIsDamaged?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Export/containerTurnoversExport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isDangerous !== undefined) {
                localVarQueryParameter['IsDangerous'] = isDangerous;
            }

            if (isDamaged !== undefined) {
                localVarQueryParameter['IsDamaged'] = isDamaged;
            }

            if (includeContainerNumber !== undefined) {
                localVarQueryParameter['IncludeContainerNumber'] = includeContainerNumber;
            }

            if (includeIsoCode !== undefined) {
                localVarQueryParameter['IncludeIsoCode'] = includeIsoCode;
            }

            if (includeOperator !== undefined) {
                localVarQueryParameter['IncludeOperator'] = includeOperator;
            }

            if (includeGrossWeight !== undefined) {
                localVarQueryParameter['IncludeGrossWeight'] = includeGrossWeight;
            }

            if (includeIsOOG !== undefined) {
                localVarQueryParameter['IncludeIsOOG'] = includeIsOOG;
            }

            if (includeIsReefer !== undefined) {
                localVarQueryParameter['IncludeIsReefer'] = includeIsReefer;
            }

            if (includeIsEmpty !== undefined) {
                localVarQueryParameter['IncludeIsEmpty'] = includeIsEmpty;
            }

            if (includeIsDangerous !== undefined) {
                localVarQueryParameter['IncludeIsDangerous'] = includeIsDangerous;
            }

            if (includeEntryDateTime !== undefined) {
                localVarQueryParameter['IncludeEntryDateTime'] = includeEntryDateTime;
            }

            if (includeIsDamaged !== undefined) {
                localVarQueryParameter['IncludeIsDamaged'] = includeIsDamaged;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        exportCustomerBillingData: async (customerId?: number, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Export/customerBillingExport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['CustomerId'] = customerId;
            }

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {boolean} [byStock] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        exportGcStoragePrebillingData: async (ids?: Array<number>, byStock?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Export/gcStoragePreBillingReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (byStock !== undefined) {
                localVarQueryParameter['byStock'] = byStock;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        exportHandlingServicesPrebillingReport: async (ids?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Export/serviceHandlingPrebillingReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {StorageReportType} [storageReportType] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        exportNonVesselContainers: async (start?: string, end?: string, storageReportType?: StorageReportType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Export/storageExport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (storageReportType !== undefined) {
                localVarQueryParameter['storageReportType'] = storageReportType;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        exportServiceOrdersReport: async (customerId?: number, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Export/serviceOrdersReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['CustomerId'] = customerId;
            }

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [vesselVisitId] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        exportVesselContainers: async (vesselVisitId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Export/vesselExport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vesselVisitId !== undefined) {
                localVarQueryParameter['vesselVisitId'] = vesselVisitId;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillableItemsData: async (customerId?: number, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Export/billableItemsData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['CustomerId'] = customerId;
            }

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [isDangerous] 
         * @param {boolean} [isDamaged] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContainerTurnoversData: async (isDangerous?: boolean, isDamaged?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Export/containerTurnoversData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isDangerous !== undefined) {
                localVarQueryParameter['IsDangerous'] = isDangerous;
            }

            if (isDamaged !== undefined) {
                localVarQueryParameter['IsDamaged'] = isDamaged;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerBillingData: async (customerId?: number, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Export/customerBillingData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['CustomerId'] = customerId;
            }

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {boolean} [byStock] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGcStoragePrebillingData: async (customerId?: number, from?: string, to?: string, byStock?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Export/gcStoragePreBillingData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['CustomerId'] = customerId;
            }

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (byStock !== undefined) {
                localVarQueryParameter['byStock'] = byStock;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHandlingServicesData: async (customerId?: number, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Export/serviceHandlingPrebillingData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['CustomerId'] = customerId;
            }

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceOrdersData: async (customerId?: number, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Export/serviceOrdersData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['CustomerId'] = customerId;
            }

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {StorageReportType} [storageReportType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStorageData: async (start?: string, end?: string, storageReportType?: StorageReportType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Export/storageData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (storageReportType !== undefined) {
                localVarQueryParameter['storageReportType'] = storageReportType;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {StorageReportType} [storageReportType] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getStorageSummary: async (start?: string, end?: string, storageReportType?: StorageReportType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Export/storageSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (storageReportType !== undefined) {
                localVarQueryParameter['storageReportType'] = storageReportType;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {StorageReportType} [storageReportType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStorageSummaryData: async (start?: string, end?: string, storageReportType?: StorageReportType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Export/storageSummaryData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (storageReportType !== undefined) {
                localVarQueryParameter['storageReportType'] = storageReportType;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [vesselVisitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselData: async (vesselVisitId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Export/vesselData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vesselVisitId !== undefined) {
                localVarQueryParameter['vesselVisitId'] = vesselVisitId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [vesselVisitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselSummary: async (vesselVisitId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Export/vesselSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vesselVisitId !== undefined) {
                localVarQueryParameter['vesselVisitId'] = vesselVisitId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExportApi - functional programming interface
 */
export const ExportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async exportBillableItemsReport(customerId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportBillableItemsReport(customerId, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.exportBillableItemsReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [isDangerous] 
         * @param {boolean} [isDamaged] 
         * @param {boolean} [includeContainerNumber] 
         * @param {boolean} [includeIsoCode] 
         * @param {boolean} [includeOperator] 
         * @param {boolean} [includeGrossWeight] 
         * @param {boolean} [includeIsOOG] 
         * @param {boolean} [includeIsReefer] 
         * @param {boolean} [includeIsEmpty] 
         * @param {boolean} [includeIsDangerous] 
         * @param {boolean} [includeEntryDateTime] 
         * @param {boolean} [includeIsDamaged] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async exportContainerTurnovers(isDangerous?: boolean, isDamaged?: boolean, includeContainerNumber?: boolean, includeIsoCode?: boolean, includeOperator?: boolean, includeGrossWeight?: boolean, includeIsOOG?: boolean, includeIsReefer?: boolean, includeIsEmpty?: boolean, includeIsDangerous?: boolean, includeEntryDateTime?: boolean, includeIsDamaged?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportContainerTurnovers(isDangerous, isDamaged, includeContainerNumber, includeIsoCode, includeOperator, includeGrossWeight, includeIsOOG, includeIsReefer, includeIsEmpty, includeIsDangerous, includeEntryDateTime, includeIsDamaged, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.exportContainerTurnovers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async exportCustomerBillingData(customerId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportCustomerBillingData(customerId, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.exportCustomerBillingData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {boolean} [byStock] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async exportGcStoragePrebillingData(ids?: Array<number>, byStock?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportGcStoragePrebillingData(ids, byStock, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.exportGcStoragePrebillingData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async exportHandlingServicesPrebillingReport(ids?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportHandlingServicesPrebillingReport(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.exportHandlingServicesPrebillingReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {StorageReportType} [storageReportType] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async exportNonVesselContainers(start?: string, end?: string, storageReportType?: StorageReportType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportNonVesselContainers(start, end, storageReportType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.exportNonVesselContainers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async exportServiceOrdersReport(customerId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportServiceOrdersReport(customerId, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.exportServiceOrdersReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [vesselVisitId] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async exportVesselContainers(vesselVisitId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportVesselContainers(vesselVisitId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.exportVesselContainers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillableItemsData(customerId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Container>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillableItemsData(customerId, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.getBillableItemsData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [isDangerous] 
         * @param {boolean} [isDamaged] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContainerTurnoversData(isDangerous?: boolean, isDamaged?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerTurnoverDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContainerTurnoversData(isDangerous, isDamaged, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.getContainerTurnoversData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerBillingData(customerId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerJourneyDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerBillingData(customerId, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.getCustomerBillingData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {boolean} [byStock] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGcStoragePrebillingData(customerId?: number, from?: string, to?: string, byStock?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GCStorageDataResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGcStoragePrebillingData(customerId, from, to, byStock, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.getGcStoragePrebillingData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHandlingServicesData(customerId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HandlingServicesDataResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHandlingServicesData(customerId, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.getHandlingServicesData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceOrdersData(customerId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServiceOrderReportDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceOrdersData(customerId, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.getServiceOrdersData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {StorageReportType} [storageReportType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStorageData(start?: string, end?: string, storageReportType?: StorageReportType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StorageReportEntry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStorageData(start, end, storageReportType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.getStorageData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {StorageReportType} [storageReportType] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getStorageSummary(start?: string, end?: string, storageReportType?: StorageReportType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StorageSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStorageSummary(start, end, storageReportType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.getStorageSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {StorageReportType} [storageReportType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStorageSummaryData(start?: string, end?: string, storageReportType?: StorageReportType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StorageSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStorageSummaryData(start, end, storageReportType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.getStorageSummaryData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [vesselVisitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselData(vesselVisitId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VesselReportContainerEntry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselData(vesselVisitId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.getVesselData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [vesselVisitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselSummary(vesselVisitId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VesselSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselSummary(vesselVisitId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportApi.getVesselSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExportApi - factory interface
 */
export const ExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExportApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        exportBillableItemsReport(customerId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.exportBillableItemsReport(customerId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [isDangerous] 
         * @param {boolean} [isDamaged] 
         * @param {boolean} [includeContainerNumber] 
         * @param {boolean} [includeIsoCode] 
         * @param {boolean} [includeOperator] 
         * @param {boolean} [includeGrossWeight] 
         * @param {boolean} [includeIsOOG] 
         * @param {boolean} [includeIsReefer] 
         * @param {boolean} [includeIsEmpty] 
         * @param {boolean} [includeIsDangerous] 
         * @param {boolean} [includeEntryDateTime] 
         * @param {boolean} [includeIsDamaged] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        exportContainerTurnovers(isDangerous?: boolean, isDamaged?: boolean, includeContainerNumber?: boolean, includeIsoCode?: boolean, includeOperator?: boolean, includeGrossWeight?: boolean, includeIsOOG?: boolean, includeIsReefer?: boolean, includeIsEmpty?: boolean, includeIsDangerous?: boolean, includeEntryDateTime?: boolean, includeIsDamaged?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.exportContainerTurnovers(isDangerous, isDamaged, includeContainerNumber, includeIsoCode, includeOperator, includeGrossWeight, includeIsOOG, includeIsReefer, includeIsEmpty, includeIsDangerous, includeEntryDateTime, includeIsDamaged, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        exportCustomerBillingData(customerId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.exportCustomerBillingData(customerId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {boolean} [byStock] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        exportGcStoragePrebillingData(ids?: Array<number>, byStock?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.exportGcStoragePrebillingData(ids, byStock, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        exportHandlingServicesPrebillingReport(ids?: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.exportHandlingServicesPrebillingReport(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {StorageReportType} [storageReportType] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        exportNonVesselContainers(start?: string, end?: string, storageReportType?: StorageReportType, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.exportNonVesselContainers(start, end, storageReportType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        exportServiceOrdersReport(customerId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.exportServiceOrdersReport(customerId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [vesselVisitId] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        exportVesselContainers(vesselVisitId?: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.exportVesselContainers(vesselVisitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillableItemsData(customerId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Container>> {
            return localVarFp.getBillableItemsData(customerId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [isDangerous] 
         * @param {boolean} [isDamaged] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContainerTurnoversData(isDangerous?: boolean, isDamaged?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerTurnoverDto>> {
            return localVarFp.getContainerTurnoversData(isDangerous, isDamaged, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerBillingData(customerId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerJourneyDto>> {
            return localVarFp.getCustomerBillingData(customerId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {boolean} [byStock] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGcStoragePrebillingData(customerId?: number, from?: string, to?: string, byStock?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<GCStorageDataResult> {
            return localVarFp.getGcStoragePrebillingData(customerId, from, to, byStock, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHandlingServicesData(customerId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<HandlingServicesDataResult> {
            return localVarFp.getHandlingServicesData(customerId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [customerId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceOrdersData(customerId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceOrderReportDto>> {
            return localVarFp.getServiceOrdersData(customerId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {StorageReportType} [storageReportType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStorageData(start?: string, end?: string, storageReportType?: StorageReportType, options?: RawAxiosRequestConfig): AxiosPromise<Array<StorageReportEntry>> {
            return localVarFp.getStorageData(start, end, storageReportType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {StorageReportType} [storageReportType] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getStorageSummary(start?: string, end?: string, storageReportType?: StorageReportType, options?: RawAxiosRequestConfig): AxiosPromise<Array<StorageSummaryDto>> {
            return localVarFp.getStorageSummary(start, end, storageReportType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {StorageReportType} [storageReportType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStorageSummaryData(start?: string, end?: string, storageReportType?: StorageReportType, options?: RawAxiosRequestConfig): AxiosPromise<Array<StorageSummaryDto>> {
            return localVarFp.getStorageSummaryData(start, end, storageReportType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [vesselVisitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselData(vesselVisitId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<VesselReportContainerEntry>> {
            return localVarFp.getVesselData(vesselVisitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [vesselVisitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselSummary(vesselVisitId?: number, options?: RawAxiosRequestConfig): AxiosPromise<VesselSummaryDto> {
            return localVarFp.getVesselSummary(vesselVisitId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExportApi - object-oriented interface
 */
export class ExportApi extends BaseAPI {
    /**
     * 
     * @param {number} [customerId] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public exportBillableItemsReport(customerId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).exportBillableItemsReport(customerId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [isDangerous] 
     * @param {boolean} [isDamaged] 
     * @param {boolean} [includeContainerNumber] 
     * @param {boolean} [includeIsoCode] 
     * @param {boolean} [includeOperator] 
     * @param {boolean} [includeGrossWeight] 
     * @param {boolean} [includeIsOOG] 
     * @param {boolean} [includeIsReefer] 
     * @param {boolean} [includeIsEmpty] 
     * @param {boolean} [includeIsDangerous] 
     * @param {boolean} [includeEntryDateTime] 
     * @param {boolean} [includeIsDamaged] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public exportContainerTurnovers(isDangerous?: boolean, isDamaged?: boolean, includeContainerNumber?: boolean, includeIsoCode?: boolean, includeOperator?: boolean, includeGrossWeight?: boolean, includeIsOOG?: boolean, includeIsReefer?: boolean, includeIsEmpty?: boolean, includeIsDangerous?: boolean, includeEntryDateTime?: boolean, includeIsDamaged?: boolean, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).exportContainerTurnovers(isDangerous, isDamaged, includeContainerNumber, includeIsoCode, includeOperator, includeGrossWeight, includeIsOOG, includeIsReefer, includeIsEmpty, includeIsDangerous, includeEntryDateTime, includeIsDamaged, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [customerId] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public exportCustomerBillingData(customerId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).exportCustomerBillingData(customerId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {boolean} [byStock] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public exportGcStoragePrebillingData(ids?: Array<number>, byStock?: boolean, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).exportGcStoragePrebillingData(ids, byStock, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public exportHandlingServicesPrebillingReport(ids?: Array<number>, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).exportHandlingServicesPrebillingReport(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [start] 
     * @param {string} [end] 
     * @param {StorageReportType} [storageReportType] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public exportNonVesselContainers(start?: string, end?: string, storageReportType?: StorageReportType, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).exportNonVesselContainers(start, end, storageReportType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [customerId] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public exportServiceOrdersReport(customerId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).exportServiceOrdersReport(customerId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [vesselVisitId] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public exportVesselContainers(vesselVisitId?: number, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).exportVesselContainers(vesselVisitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [customerId] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBillableItemsData(customerId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).getBillableItemsData(customerId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [isDangerous] 
     * @param {boolean} [isDamaged] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getContainerTurnoversData(isDangerous?: boolean, isDamaged?: boolean, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).getContainerTurnoversData(isDangerous, isDamaged, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [customerId] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomerBillingData(customerId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).getCustomerBillingData(customerId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [customerId] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {boolean} [byStock] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGcStoragePrebillingData(customerId?: number, from?: string, to?: string, byStock?: boolean, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).getGcStoragePrebillingData(customerId, from, to, byStock, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [customerId] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getHandlingServicesData(customerId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).getHandlingServicesData(customerId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [customerId] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getServiceOrdersData(customerId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).getServiceOrdersData(customerId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [start] 
     * @param {string} [end] 
     * @param {StorageReportType} [storageReportType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getStorageData(start?: string, end?: string, storageReportType?: StorageReportType, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).getStorageData(start, end, storageReportType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [start] 
     * @param {string} [end] 
     * @param {StorageReportType} [storageReportType] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public getStorageSummary(start?: string, end?: string, storageReportType?: StorageReportType, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).getStorageSummary(start, end, storageReportType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [start] 
     * @param {string} [end] 
     * @param {StorageReportType} [storageReportType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getStorageSummaryData(start?: string, end?: string, storageReportType?: StorageReportType, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).getStorageSummaryData(start, end, storageReportType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [vesselVisitId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselData(vesselVisitId?: number, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).getVesselData(vesselVisitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [vesselVisitId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselSummary(vesselVisitId?: number, options?: RawAxiosRequestConfig) {
        return ExportApiFp(this.configuration).getVesselSummary(vesselVisitId, options).then((request) => request(this.axios, this.basePath));
    }
}

